import { CancelTokenSource } from 'axios';
import { EntryFavoriteDto } from 'ts-types/api.types';
import axios from './http';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/entry-favorites`;

/** Favorite entries (procedures, block procedures, medicaments) of a mandate, shared by all its users. */
export const getEntryFavorites = (
    mandateId: number, source: CancelTokenSource): Promise<Array<EntryFavoriteDto>> => {

  return axios
      .get(apiUri, { params: { mandateId }, cancelToken: source.token })
      .then(response => response.data);
};

/** Marks the entry as favorite of the mandate if it is not one yet, otherwise removes the mark. Returns the new state. */
export const toggleEntryFavorite = (
    entryFavorite: EntryFavoriteDto,
    source: CancelTokenSource): Promise<EntryFavoriteDto> => {

  return axios
      .put(`${apiUri}/toggle`, entryFavorite, { cancelToken: source.token })
      .then(response => response.data);
};
